import { withTranslation } from "react-i18next";
import withRouter from "../../../../components/Common/withRouter";
import { useDispatch, useSelector } from "react-redux";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";
import { loadDeductions as onLoadDeductions, deleteDeduction as onDeleteDeduction, getSalaryTypes } from "../../../../slice/payroll/thunks";
import { createSelector } from "reselect";
import { Link } from "react-router-dom";
import GlobalLoader from "../../../../components/Common/GlobalLoader";
import BreadCrumb from "../../../../components/Common/BreadCrumb";
import TableContainerWarehouse from "../../../../components/Common/TableContainerWarehouse";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";


const Deductions = (props) => {

  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState(true)
  const [deductionToDelete, setDeductionToDelete] = useState(null);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isDeleted, setIsDeleted] = useState(false);

  const selectLayoutState = (state) => state.Payroll;
  const PayrollStore = createSelector(
    selectLayoutState,
    (payroll) => ({
      deductions: payroll?.deductions ?? [],
      error: payroll?.error ?? null,
      salaryTypes: payroll?.salaryTypes ?? [],
    })
  )
  const { deductions, error, salaryTypes } = useSelector(PayrollStore)

  const handleDeleteClick = useCallback((deductionToDelete) => {
    setDeductionToDelete(deductionToDelete);
    setIsDeleteModalOpen(true);
  });

  const loadDeductions = useCallback((page, size) => {
    dispatch(onLoadDeductions({ page: page, size: size }))
      .unwrap()
      .then(() => {
        setIsLoading(false);
        setDeductionToDelete(null);
      });
  }, [dispatch, setDeductionToDelete]);

  const confirmDelete = useCallback(() => {
    if (!deductionToDelete) return;

    dispatch(onDeleteDeduction(deductionToDelete.id))
      .unwrap()
      .then((response) => {
        setIsDeleteModalOpen(false);
        setIsDeleted(true);
        toast.success(response.message);
        loadDeductions();
      }).catch((error) => {
        setIsDeleteModalOpen(false);
        loadDeductions();
        toast.error(error.message || "Failed to delete deduction");
      });
  }, [dispatch, deductionToDelete, setIsDeleteModalOpen, setIsDeleted, loadDeductions]);

  useEffect(() => {
    loadDeductions();
    dispatch(getSalaryTypes());
  }, [dispatch]);


  const columns = useMemo(() => [
    {
      header: props.t("no"),
      style: "button",
      enableColumnFilter: false,
      cell: (cellProps) => {
        return (
          <span>
            {deductions && deductions.page === 1 ?
              cellProps.row.index + 1
            : (deductions && deductions.page - 1) * 10 + cellProps.row.index + 1
            }
          </span>
        );
      },
    },
    {
      header: props.t("deduction_name"),
      accessorKey: "name",
      style: "button",
      enableColumnFilter: false,
      sortable: false,
    },
    {
      header: props.t("contribution_type"),
      accessorKey: "contributionType",
      style: "button",
      enableColumnFilter: false,
      sortable: false,
    },
    {
      header: props.t("category_name"),
      accessorKey: "categoryName",
      style: "button",
      enableColumnFilter: false,
      sortable: false,
    },
    {
      header: props.t("to_deduct_from"),
      accessorKey: "appliedTo",
      style: "button",
      enableColumnFilter: false,
      sortable: false,
	  cell: (cellProps) => {
		const appliedTo = cellProps.row.original.appliedTo;
		return (
		  <span>
			{salaryTypes?.find((salaryType) => salaryType.value === appliedTo)?.title || "--------"}
		  </span>
		);}
    },
    /* {
              header: props.t("rate_or_amount"),
              accessorKey: "rateOrAmount",
              style: "button",
              enableColumnFilter: false,
              sortable: false,
            }, */
    {
      header: props.t("action"),
      style: "text-end",
      cell: (cellProps) => {
        return (
          <div className="d-flex justify-content-end">
            <ul className="list-inline hstack mb-0">
              <li className="list-inline-item edit" title="Edit">
                <Link
                  to={`/payroll/deductions/${cellProps.row.original.id}/edit`}
                  className="text-info d-inline-block edit-item-btn">
                  <i className="fa fa-pencil" aria-hidden="true"></i>
                </Link>
              </li>
              <li className="list-inline-item" title="Settings">
                <Link
                  to={`/payroll/deductions/${cellProps.row.original.id}/settings`}
                  className="text-success d-inline-block remove-item-btn">
                  <i className="fa fa-building-un" aria-hidden="true"></i>
                </Link>
              </li>
              <li className="list-inline-item" title="Remove">
                <Link
                  to="#"
                  className="text-danger d-inline-block remove-item-btn"
                  onClick={() => handleDeleteClick(cellProps.row.original)}>
                  <i className="fa fa-trash" aria-hidden="true"></i>
                </Link>
              </li>
            </ul>
          </div>
        );
      },
    },
  ]);

  return (
    <React.Fragment>
      {isLoading ?
        <GlobalLoader />
        :
        <>
          {/* <DeleteModal show={deleteModal} onDeleteClick={handleDeleteBeds} onCloseClick={() =>setDeleteModal(false)} /> */}
          <div className="deduction-categories px-3">
            <div className="patients-list py-4 px-2  ">
              <div className="container-fluid">
                <div className="row list-patients d-flex  justify-content-between">
                  <Link to="/payroll/setting" className="col-lg-5">
                    <BreadCrumb title={props.t("payroll_settings")} pageTitle={props.t("deductions")} />
                  </Link>
                  <div className="col-sm-auto new-mode-btn">
                    <Link to="/payroll/deductions/add" className="btn btn-std mx-2" >
                      <i className="fas fa-user-md mx-1"></i>
                      {props.t("add_deduction")}
                    </Link>
                  </div>
                </div>

                <div className="dedections">
                  <div className="container-fluid">
                    <div className="row justify-content-between">
                      <div className="card table-card">
                        <TableContainerWarehouse
                          columns={columns}
                          data={deductions?.items ?? []}
                          customPageSize={10}
                          tableSize={deductions && deductions.size}
                          tablePage={deductions && deductions.page}
                          tableTotal={deductions && deductions.total_items}
                          tableTotalPage={deductions && deductions.total_page}
                          onNextPage={loadDeductions}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


          {/* Modal Confirmation Delete */}
          <Modal
            isOpen={isDeleteModalOpen}
            toggle={() => setIsDeleteModalOpen(!isDeleteModalOpen)}
            centered
          >
            <ModalHeader toggle={() => setIsDeleteModalOpen(false)}>
              {props.t("confirm_delete")}
            </ModalHeader>
            <ModalBody>
              {props.t("are_you_sure_delete")}{" "}
              <strong>{deductionToDelete?.name}</strong> ?
            </ModalBody>
            <ModalFooter>
              <Button color="danger" onClick={confirmDelete}>
                {props.t("delete")}
              </Button>
              <Button color="secondary" onClick={() => setIsDeleteModalOpen(false)}>
                {props.t("cancel")}
              </Button>
            </ModalFooter>
          </Modal>
        </>
      }
    </React.Fragment>
  );
}

export default withRouter(withTranslation()(Deductions));